import '../../libs/slick/slick-theme.css'
import { Link } from 'react-router-dom'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { types, Instance } from 'mobx-state-tree'
import * as React from 'react'
import styled from 'styled-components'
import Swal from 'sweetalert2'
import { RouteComponentProps, withRouter } from 'react-router'
import {
  GetOwnIntakeQuery_getOwnIntake,
  UpdateMovieWatchedMutation,
  UpdateMovieWatchedMutationVariables,
} from '../../schema/schemaTypes'
import { intakeMetrics } from '../Intakes/intakeMetrics/calcIntakeMetrics'
import Box, { Row } from '../../atoms/Box'
import Image from '../../atoms/Image'
import {ExecutionResult} from 'graphql'
import {apolloClient} from '../../utils/apolloClient'
import {UPDATE_MOVIE_WATCHED} from '../../mutations/UPDATE_MOVIE_WATCHED'

let cloudinaryUrlPNG: string
let cloudinaryUrlJPG: string
if (window.innerWidth < 400) {
  cloudinaryUrlPNG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/w_600,c_scale,f_png/'
  cloudinaryUrlJPG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/w_800,c_scale,f_jpg/'
} else {
  cloudinaryUrlPNG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/f_png/'
  cloudinaryUrlJPG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/f_jpg/'
}

const UpSpace= styled.div`
  height: 30px;

  @media (max-width: 900px) {
    height: 80px
  }
`

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

// tslint:disable:max-line-length object-literal-sort-keys
//
const Container = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    background: #C7F0F6;
    top: 20px;
    border-radius: 10px;
    padding-top: 30px;
    padding-bottom: 30px;
    z-index: 1;
    box-shadow: 0 8px 40px 0 rgba(194, 111, 35, 0.2), 0 16px 80px 0 rgba(194, 111, 35, 0.2);
`

const SelectedBox = styled.div<{ color?: string}>`
    position: absolute;
    top: 10px;
    border-width: 5px;
    border-color: white;
    border-style: solid;
    border-radius: 10px;
    transform: translate(0, -50px) rotate(3deg);
    color: white;
    padding-top: 20px;
    text-align: center;
    height: 103px;
    background-color: ${({ color}) => color };
    width: 100%;
    font-family: Nunito;
    font-weight: 900;

  @media (max-width: 900px) {
    padding-top: 10px;
    transform: translate(0, -60px) rotate(3deg);
  }

  @media (max-width: 550px) {
    padding-top: 10px;
    transform: translate(0, -80px) rotate(3deg);
  }
`

const UnselectedBox = styled.div<{ color?: string}>`
    position: absolute;
    top: 10px;
    transform: translate(0, -35px);
    border-width: 2px;
    border-color: #3F6EA2;
    border-style: solid;
    border-radius: 10px;
    color: white;
    padding-top: 10px;
    text-align: center;
    height: 103px;
    background-color: ${({ color}) => color };
    width: 100%;
    font-family: Nunito;

    @media (max-width: 900px) {
      padding-top: 10px;
      transform: translate(0, -60px) ;
    }
`

const SelectedBoxSmall = styled.div<{ color?: string}>`
    border-width: 5px;
    border-color: white;
    border-style: solid;
    border-radius: 10px;
    transform: rotate(2deg);
    color: white;
    text-align: center;
    height: 50px;
    background-color: ${({ color}) => color };
    width: 100%;
    font-family: Nunito;
    font-weight: 900;
    align-items: center;
    justify-content: center;
    display: flex;
`

const UnselectedBoxSmall = styled.div<{ color?: string}>`
    border-width: 2px;
    border-color: #3F6EA2;
    border-style: solid;
    border-radius: 10px;
    color: white;
    text-align: center;
    height: 50px;
    background-color: ${({ color}) => color };
    width: 100%;
    font-family: Nunito;
    align-items: center;
    justify-content: center;
    display: flex;
`


const Video = styled.video<{ id?: string; class?: string; controls?: boolean}>``

let myPlayer: any


(window as any).getPlayer = () => myPlayer

const KidsVideoModel = types.model(
  {
    childAnxiety: types.string,
    index: 0,
    isPlaying: false,
  })
  .views(self => ({
    get videoTitle() {
      if (self.index === 0) {
        return 'Kids Home before surgery'
      } else if (self.index === 1) {
        return 'Kids Waiting and anesthesia'
      } else if (self.index === 2) {
        return 'Kids Recovery room'
      } else {
        return 'Kids Back home'
      }
    },
    get playBtnName() {
      if (self.isPlaying) {
        return 'videoPause'
      } else {
        return 'videoPlay'
      }
    },
    get videoUrl() {
      switch (self.index) {
        case 0: return `https://s3-us-west-1.amazonaws.com/uci-images/video${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '/hd' : ''}/kids/M1-HA${process.env.REACT_APP_LANGUAGE === 'es' ? '_ES' : ''}.mp4`
        case 1: return `https://s3-us-west-1.amazonaws.com/uci-images/video${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '/hd' : ''}/kids/M2-HA-MzPP-Game${process.env.REACT_APP_LANGUAGE === 'es' ? '_ES' : ''}.mp4`
        case 2: return `https://s3-us-west-1.amazonaws.com/uci-images/video${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '/hd' : ''}/kids/M3${process.env.REACT_APP_LANGUAGE === 'es' ? '_ES' : ''}.mp4`
        default: return `https://s3-us-west-1.amazonaws.com/uci-images/video${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '/hd' : ''}/kids/M4${process.env.REACT_APP_LANGUAGE === 'es' ? '_ES' : ''}.mp4`
      }
    },
    get posterUrl() {
      switch (self.index) {
        case 0: return `${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/video/kids/M1-LA-preview%402x.png`
        case 1: return `${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/video/kids/M2-HA-MzPP-preview%402x.png`
        case 2: return `${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/video/kids/M3-preview%402x.png`
        default: return `${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/video/kids/M4-preview%402x.png`
      }
    },
    // M2-HA-MzPP
  }))
  .actions((self: any) => ({
    setIsPlaying(val: boolean) {
      self.isPlaying = val
    },
    pressPrev() {
      if (self.index > 0) {
        self.changeIndex(self.index - 1)
      }
      myPlayer.currentTime(0)
    },
    pressPlayStop() {
      if (myPlayer.paused()) {
        myPlayer.play()
      } else {
        myPlayer.pause()
      }
    },
    changeIndex(index: number) {
      self.index = index
      myPlayer.pause()
      myPlayer.src({type: 'video/mp4', src: self.videoUrl})
    },
    pressNext() {
      if (self.index <3) {
        self.changeIndex(self.index + 1)
      }
    },
  }))



interface IMainProp {
  store: Instance<typeof KidsVideoModel>,
  kidsMode?: boolean,
  history: any,
}

const ButtonRow  = observer(({store, history}: IMainProp) => {
  const onClick = async () => {

    const response = await Swal.fire({
      title: `<strong>${lang === 'es' ? '¿Ir al sitio de adultos?' : 'Go To Grow Ups Site?'}</strong>`,
      html:
        `${lang === 'es' ? 'Esto lo llevará de regreso al sitio de los Padres. ¿Estás seguro de que quieres irte?' : 'This will take you back to the Parent\'s site. Are you sure you want to leave?'}`,
      showCancelButton: true,
      showCloseButton: true,
      focusConfirm: false,
      confirmButtonText:
      'No',
      cancelButtonText:
        `${lang === 'es' ? 'Si' : 'Yes'}`,
    })

    console.log('response', response)
    console.log('history', history)

    if (response.dismiss === Swal.DismissReason.cancel)  {
      history.push('/welcome-back')
    }

  }
  return (
    <Row center>
      <div onClick={onClick}>
        <Image name="parentIcon" style={{height: 58, width:61}} />
      </div>
      <Box w={18} />
      <Link to="/kids-faq">
        <Image name="faqIcon" style={{height: 68, width:55}} />
      </Link>
      <Box f1 />
      <Image
        onClick={store.pressPrev}
        name="videoPrev" style={{height: 60, width:60}} />
      <Image
        onClick={store.pressPlayStop}
        name={store.playBtnName} style={{height: 70, width:70}} />
      <Image
        onClick={store.pressNext}
        name="videoNext" style={{height: 60, width:60}} />
    </Row>

  )
})


const ButtonRowSmall  = observer(({store}: IMainProp) => {
  return (
    <Row center>
      <Box f1 />
      <Image
        onClick={store.pressPrev}
        name="videoPrev" style={{height: 50, width: 50}} />
      <Image
        onClick={store.pressPlayStop}
        name={store.playBtnName} style={{height: 60, width:60}} />
      <Image
        onClick={store.pressNext}
        name="videoNext" style={{height: 50, width: 50}} />
      <Box f1 />
    </Row>

  )
})

const SelectionRowSmall = observer(({ store}: IMainProp ) => {
  const Item1 = store.index === 0 ? SelectedBoxSmall : UnselectedBoxSmall
  const Item2 = store.index === 1 ? SelectedBoxSmall : UnselectedBoxSmall
  const Item3 = store.index === 2 ? SelectedBoxSmall : UnselectedBoxSmall
  const Item4 = store.index === 3 ? SelectedBoxSmall : UnselectedBoxSmall

  return (
    <Box>
      <Box
        onClick={() => store.changeIndex(0)}
        style={{paddingLeft: 15, paddingRight: 15}}>
        <Item1 color="#FC9426"
        > {process.env.REACT_APP_LANGUAGE === 'es' ? 'Antes Cirugía' : 'Home before surgery'}</Item1>
      </Box>
      <Box h={10} />
      <Box
        onClick={() => store.changeIndex(1)}
        style={{paddingLeft: 15, paddingRight: 15}}>
        <Item2
          color="#CB8CD6"
        > {process.env.REACT_APP_LANGUAGE === 'es' ? 'Cirugía' : 'Surgery'}</Item2>
      </Box>
      <Box h={10} />
      <Box
        onClick={() => store.changeIndex(2)}
        style={{paddingLeft: 15, paddingRight: 15}}>
        <Item3
          color="#25CD78"
        > {process.env.REACT_APP_LANGUAGE === 'es' ? 'Cuarto de Recuperación' : 'Recovery Room'}</Item3>
      </Box>
      <Box h={10} />
      <Box
        onClick={() => store.changeIndex(3)}
        style={{paddingLeft: 15, paddingRight: 15}}>
        <Item4
          color="#76B4D8"
        > {process.env.REACT_APP_LANGUAGE === 'es' ? 'Despues de Cirugía' : 'Back Home'} </Item4>
      </Box>
    </Box>
  )
})


const SelectionRow = observer(({ store}: IMainProp ) => {

  const Item1 = store.index === 0 ? SelectedBox : UnselectedBox
  const Item2 = store.index === 1 ? SelectedBox : UnselectedBox
  const Item3 = store.index === 2 ? SelectedBox : UnselectedBox
  const Item4 = store.index === 3 ? SelectedBox : UnselectedBox

  return (
    <Row>
      <Box f1
        onClick={() => store.changeIndex(0)}
        style={{marginLeft: 13, position: 'relative'}}>
        <Item1 color="#FC9426"
        > {process.env.REACT_APP_LANGUAGE === 'es' ? 'Antes de cirugía' : 'Home before surgery'}</Item1>
      </Box>
      <Box f1
        onClick={() => store.changeIndex(1)}
        style={{marginLeft: 13, position: 'relative'}}>
        <Item2
          color="#CB8CD6"
        > {process.env.REACT_APP_LANGUAGE === 'es' ? 'Cirugía' : 'Surgery'}</Item2>
      </Box>
      <Box f1
        onClick={() => store.changeIndex(2)}
        style={{marginLeft: 13, position: 'relative'}}>
        <Item3
          color="#25CD78"
        >{process.env.REACT_APP_LANGUAGE === 'es' ? 'Cuarto de Recuperación' : 'Recovery Room'}</Item3>
      </Box>
      <Box f1
        onClick={() => store.changeIndex(3)}
        style={{position: 'relative', marginLeft: 13, marginRight: 13}}>
        <Item4
          color="#76B4D8"
        > {process.env.REACT_APP_LANGUAGE === 'es' ? 'Casa' : 'Back Home'}</Item4>
      </Box>

    </Row>
  )
})


interface IProps extends RouteComponentProps {
  intake: GetOwnIntakeQuery_getOwnIntake,
  history: any,
}


@observer
class KidsVideoManagerBase extends React.Component<IProps> {
  @observable public store: Instance<typeof KidsVideoModel>
  public player: any

  public constructor(props: any) {
    super(props)
    const { intake } = this.props
    const {
      childAnxiety,
    } = intakeMetrics(intake)
    this.store = KidsVideoModel.create({
      childAnxiety,
    })
  }


  public componentDidMount() {
    myPlayer = (window as any).videojs((window as any).player)
    let currentTime = 0

    myPlayer.on('seeking', () => {
      if (currentTime < myPlayer.currentTime()) {
        myPlayer.currentTime(currentTime)
      }
    })

    myPlayer.on('seeked', () => {
      if (currentTime < myPlayer.currentTime()) {
        myPlayer.currentTime(currentTime)
      }
    })

    setInterval(() => {
      if (!myPlayer.paused()) {
        currentTime = myPlayer.currentTime()
      }
    }, 1000)

    myPlayer.on('play', () => {
      (window as any).trackVideo(
        window.location.pathname,
        this.store.videoTitle,
        myPlayer.duration(),
        myPlayer.currentTime(),
        'play',
      )
    })
    myPlayer.on('playing', () => {
      this.store.setIsPlaying(true)
    })
    myPlayer.on('pause', () => {
      (window as any).trackVideo(
        window.location.pathname,
        this.store.videoTitle,
        myPlayer.duration(),
        myPlayer.currentTime(),
        'pause',
      )
      this.store.setIsPlaying(false)
    })
    myPlayer.on('ended', async () => {
      (window as any).trackVideo(
        window.location.pathname,
        this.store.videoTitle,
        myPlayer.duration(),
        myPlayer.currentTime(),
        'ended',
      )
      const { data }: ExecutionResult<UpdateMovieWatchedMutation> =
        await apolloClient.mutate<UpdateMovieWatchedMutation, UpdateMovieWatchedMutationVariables>({
          mutation: UPDATE_MOVIE_WATCHED, variables: { movieIndex: this.store.index } }) as any
          if(data && data.UpdateMovieWatched) {
            console.log('UpdateMovieWatchedMutation', data.UpdateMovieWatched)
        await Swal.fire({
          title: '<strong>Congratulations! You have finished watching this video</strong>',
          text: 'If you have watched all four videos, you can go to the activities page and print an award!',
          cancelButtonText: 'OK',
          showConfirmButton: false,
          showCancelButton: true,
          focusCancel: false,
        })
      }
    })
  }

  public componentDidUpdate() {
    myPlayer = (window as any).videojs((window as any).player)
    myPlayer.poster(this.store.posterUrl)
  }

  public render() {
    // read intake here
    const { intake, history } = this.props
    let autoPlay: boolean = false
    if(this.props.location.state) {
      autoPlay = true
    }
    const {
      childAnxiety,
    } = intakeMetrics(intake)
    console.log('childAnxiety', childAnxiety)

    let width = Math.min(window.innerWidth - 100, 800)
    let height = width / 2.1
    const store = this.store

    const goParentSite = async () => {
      const response = await Swal.fire({
        title: `<strong>${lang === 'es' ? '¿Ir al sitio de adultos?' : 'Go To Grow Ups Site?'}</strong>`,
        html:
          `${lang === 'es' ? 'Esto lo llevará de regreso al sitio de los Padres. ¿Estás seguro de que quieres irte?' : 'This will take you back to the Parent\'s site. Are you sure you want to leave?'}`,
        showCancelButton: true,
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText:
          'No',
        cancelButtonText:
          `${lang === 'es' ? 'Si' : 'Yes'}`,
      })

      console.log('response', response)
      console.log('history', history)

      if (response.dismiss === Swal.DismissReason.cancel)  {
        history.push('/welcome-back')
      }
    }



    if (window.innerWidth <= 390) {
      width = window.innerWidth
      height = width / 2.1

      return (
        <>
          <Video
            className="video-js "
            preload="auto"
            controls={true}
            width={width}
            ref={(player: any)=> (window as any).player = player}
            height={height}
            autoPlay={autoPlay}
            id="my-video"
            poster={store.posterUrl}>
            <source
              src={store.videoUrl} type="video/mp4" />
          </Video>
            <Box h={20} />
            <ButtonRowSmall history={history} store={store} />
            <Box h={37} />

            <SelectionRowSmall history={history} store={store} />

            <div
              style = {{
                position: 'fixed',
                left: 13,
                bottom: 13,
              }}
              onClick={goParentSite}
              >
              <Image name="parentIcon" style={{height: 34, width: 36}} />
            </div>

            <Link to="/kids-faq"
              style = {{
                position: 'fixed',
                right: 13,
                bottom: 13,
              }}

            >
              <Image name="faqIcon" style={{height: 40, width: 33}} />
            </Link>
          </>
      )
    }


    return (
      <>
        <div style={{position: 'relative'}}>
          <UpSpace />
          <SelectionRow history={history} store={store} />

          <Container>
            <Video
              className="video-js "
              preload="auto"
              controls={true}
              width={width}
              ref={(player: any)=> (window as any).player = player}
              height={height}
              autoPlay={autoPlay}
              id="my-video"
              poster={store.posterUrl}>
              <source
                src={store.videoUrl} type="video/mp4" />
            </Video>


          </Container>
          <Box h={42} />
          <ButtonRow history={history} store={store} />

        </div>
        <Box h={20} />
      </>
    )
  }

}


export const KidsVideoManager = withRouter(KidsVideoManagerBase)



// WEBPACK FOOTER //
// ./src/organisms/KidsVideo/KidsVideoManager.tsx